import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MailInSettings } from "components/settings/mail-in-settings";
import {
  saveAddressAction,
  updateDocReturnAction
} from "actions/account-settings-actions";
import { Loading } from "components/common/loading";

const MailInSettingsPage = (props) => {
  if (props.isLoading) {
    return <Loading />;
  }
  return (
    <MailInSettings { ...props } />
  );
};

MailInSettingsPage.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  address: state.accountSettings.address,
  docReturn: state.accountSettings.docReturn,
  isDocumentReturnLoading: state.accountSettings.isDocumentReturnLoading,
  isLoading: state.accountSettings.isLoading,
  slug: state.accountSettings.slug,
  vip: state.accountSettings.vip
});

const mapDispatchToProps = (dispatch) => ({
  onDisableDocReturn: (accountId) => dispatch(updateDocReturnAction(accountId, false)),
  onEnableDocReturn: (accountId) => dispatch(updateDocReturnAction(accountId, true)),
  onSaveAddress: () => dispatch(saveAddressAction())
});

export const MailInSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(MailInSettingsPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/mail-in-settings-container.jsx